/** Removes the Discogs " (n)" suffix that tells apart artists with the same name. */
export function displayArtist(name: string): string {
  return name.replace(/\s+\(\d+\)$/, '').trim();
}

/** Sort key for artists: suffix removed, a leading "The " ignored, lower case. */
export function artistSortKey(name: string): string {
  return displayArtist(name)
    .replace(/^the\s+/i, '')
    .toLocaleLowerCase('en');
}

/**
 * Natural sort key: numbers compare by value, so "Shelf 2" sorts before
 * "Shelf 10". Numbers are zero-padded to 10 digits.
 */
export function naturalSortKey(text: string): string {
  return text
    .trim()
    .toLocaleLowerCase('en')
    .replace(/\d+/g, (n) => n.replace(/^0+(?=\d)/, '').padStart(10, '0'));
}
